import classNames from "classnames"
import { AnimatePresence } from "motion/react"

import { StyledComponent } from "@/topic/rogue_4/types"
import GameModalLayer from "../components/Modal"
import { UIButtonLayer } from "../components/RightButton"
import { EGameScene, useGameStore } from "../store"
import GameSceneGame from "./game"
import GameSceneLoading from "./loading"
import GameSceneLobby from "./lobby"
import GameSceneRecord from "./record"
import GameSceneResult from "./result"

import styles from "./index.module.less"

const GameLayer: StyledComponent<{ back?: () => void }> = ({
    className,
    style,
    back,
}) => {
    const { scene, gameType } = useGameStore()

    return (
        <div className={classNames(styles.gameLayer, className)} style={style}>
            <div className={styles.bgContainer}>
                <div
                    className={classNames(
                        styles.bgItem,
                        styles.loading,
                        scene === EGameScene.Loading && styles.active
                    )}
                ></div>
                <div
                    className={classNames(
                        styles.bgItem,
                        styles.lobby,
                        scene === EGameScene.Lobby && styles.active
                    )}
                ></div>
                <div
                    className={classNames(
                        styles.bgItem,
                        styles.game,
                        (([EGameScene.Result, EGameScene.Record].includes(
                            scene
                        ) &&
                            gameType === "normal") ||
                            scene === EGameScene.Game) &&
                            styles.active
                    )}
                ></div>
                <div
                    className={classNames(
                        styles.bgItem,
                        styles.gameSpecial,
                        [EGameScene.Result, EGameScene.Record].includes(
                            scene
                        ) &&
                            gameType === "rhodes" &&
                            styles.active
                    )}
                ></div>
            </div>
            <AnimatePresence mode="wait">
                {scene === EGameScene.Loading && (
                    <GameSceneLoading
                        key={scene}
                        style={{ transform: "translate3d(0, 0, 0)" }}
                    />
                )}
                {scene === EGameScene.Lobby && (
                    <GameSceneLobby
                        key={scene}
                        style={{ transform: "translate3d(0, 0, 0)" }}
                    />
                )}
                {scene === EGameScene.Game && (
                    <GameSceneGame
                        key={scene}
                        style={{ transform: "translate3d(0, 0, 0)" }}
                    />
                )}
                {scene === EGameScene.Result && (
                    <GameSceneResult
                        key={scene}
                        style={{ transform: "translate3d(0, 0, 0)" }}
                    />
                )}
                {scene === EGameScene.Record && (
                    <GameSceneRecord
                        key={scene}
                        style={{ transform: "translate3d(0, 0, 0)" }}
                    />
                )}
            </AnimatePresence>
            <UIButtonLayer back={back} />
            <GameModalLayer />
        </div>
    )
}

export default GameLayer
